<template>
  <div class="table-box">
    <div class="search-box">
      <div class="search-left">
        <div>
          <span>接单企业：</span>
          <dic-select
            @dic-select-obj="saveProId"
            :fuzzyDef="searchAjax"
            :prop="prop"
            placeholder="请输入接单企业名称"
            ajaxQuery="title"
          />
        </div>
        <div>
          <span>项目名称：</span>
          <el-input
            class="search-input"
            v-model="searchQuery.projectName"
            placeholder="请输入项目名称"
            clearable
          />
        </div>
        <div>
          <span>提交日期：</span>
          <el-date-picker
            @change="dateChange"
            v-model="dateValue"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="提交日期起"
            end-placeholder="提交日期止"
          />
        </div>
        <div>
          <span>签约状态：</span>
          <el-select
            v-model="searchQuery.status"
            style="margin-right:20px;"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="item in linkStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>
      <div class="search-right">
        <el-button type="primary" @click="searchEvent">搜索</el-button>
      </div>
    </div>
    <!--列表-->
    <div class>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column type="index" label="序号" align="center" width="80" />
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="enterpriseName"
          label="接单企业"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectName"
          label="项目名称"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskMonth"
          label="提交日期"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="任务状态"
        >
          <template slot-scope="scope">
            {{ scope.row | transAuditStatus }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="电子结算单"
        >
          <template slot-scope="scope">
            {{ scope.row | transContract }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="detail(scope)"
              :disabled="scope.row.csoStatus != 1"
            >
              数据报告
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="accept(scope)"
              :disabled="
                scope.row.csoStatus != 1 || scope.row.industryConfirm != 0
              "
            >
              接收任务
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="signContract(scope.row)"
              v-if="scope.row.status !== 2 && scope.row.status !== 5"
              :disabled="
                scope.row.industryConfirm === 0 ||
                  scope.row.status !== 1 ||
                  scope.row.isSign === 1
              "
            >
              签约
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="checkRes(scope.row)"
              :disabled="
                !(
                  scope.row.firstStatus == 2 &&
                  scope.row.secondStatus == 2 &&
                  scope.row.industryConfirm == 1
                )
              "
              v-else
            >
              查看
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="download(scope.row)"
              :disabled="
                !(
                  scope.row.firstStatus == 2 &&
                  scope.row.secondStatus == 2 &&
                  scope.row.industryConfirm == 1
                )
              "
            >
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      />
    </div>
  </div>
</template>

<script>
import datePicker from '@/Mixin/datePicker';
import { project, eContract, bingli, receive } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import { mapMutations, mapActions } from 'vuex';
import OpenNewWin from '@/tools/openNewWin';
import { projectAllList } from '@/config/staticData';
import { setStorage } from '@/tools/storage';

const ysId = [7, 8];
let _arr = [];
projectAllList.filter((item, index) => {
  _arr.push(index + 1);
});
export default {
  mixins: [pageInation, makeSure],

  data() {
    return {
      dateValue: [],
      projectAllList,
      linkStatus: [
        {
          value: 0,
          label: '待我签'
        },
        {
          value: 1,
          label: '待他签'
        },
        {
          value: 2,
          label: '已完成'
        }
      ],
      ruleForm: {
        taskDate: ''
      }, // 用户信息
      getList: eContract.signList, // 获取列表的AJAX
      searchQuery: {
        projectName: '',
        enterpriseId: '',
        taskMonth: '',
        status: ''
      },
      searchAjax: eContract.enterpriseList,
      prop: {
        label: 'enterpriseName',
        code: 'id'
      }
    };
  },
  components: {
    dicSelect
  },
  computed: {},
  methods: {
    ...mapActions(['setHomeQuery']),
    ...mapMutations(['CLEAN_HOME']),
    dateChange(value) {
      this.searchQuery.startDt = value ? value[0] : '';
      this.searchQuery.endDt = value ? value[1] : '';
    },
    signContract(row) {
      //签约
      let win = new OpenNewWin();
      this.projectType = row.projectType;

      win.createWin();
      const arr = _arr;
      if (arr.includes(this.projectType)) {
        receive
          .signStatement({
            statementId: row.id,
            signType: row.signType
          })
          .then(res => {
            win.setUrl(res.data.data);
            this.$confirm(
              '请在新打开的页面完成签约，签约成功请点击完成',
              '提示',
              {
                confirmButtonText: '完成',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
              .then(() => {
                this.initWatchRouteChange();
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });
                this.initWatchRouteChange();
              });
          });
      } else {
        eContract
          .firstYshSign({ id: row.id, signingId: row.signingId })
          .then(res => {
            win.setUrl(res.data.data.signUrl);
            this.$confirm(
              '请在新打开的页面完成签约，签约成功请点击完成',
              '提示',
              {
                confirmButtonText: '完成',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
              .then(() => {
                this.initWatchRouteChange();
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });
                this.initWatchRouteChange();
              });
          });
      }
    },
    checkRes(row) {
      //查看电子合同
      let win = new OpenNewWin();
      win.createWin();
      if (!ysId.includes(row.projectType)) {
        //医学助手联盟
        eContract
          .lookContract({ id: row.id, type: 1, signingId: row.signingId })
          .then(res => {
            win.setUrl(res.data.data);
          });
      } else {
        //医生汇联盟
        eContract
          .lookContract({ id: row.id, type: 2, signingId: row.signingId })
          .then(res => {
            win.setUrl(res.data.data);
          });
      }
    },
    download(row) {
      this.projectType = row.projectType;
      const arr = _arr;
      this.$downloadFile(
        `${eContract.downloadContractUrl}?id=${row.id}&signingId=${
          row.signingId
        }&type=${arr.includes(this.projectType) ? 1 : 2}`,
        true
      );
    },
    submitAjax(type) {
      //编辑的接口
      if (type == 8) {
        return bingli.yshIndustryConfirm;
      } else if (type == 5) {
        return project.dcwjIndustryConfirm;
      } else if (type == 7) {
        return project.yshIndustryConfirm;
      } else {
        return project.industryConfirm;
      }
    },
    accept(scope) {
      let item = scope.row;
      this.setHomeQuery({ ...item, id: item.projectId }).then(() => {
        this.$router.push({
          path: '/accept/index',
          query: {
            id: item.projectId
          }
        });
      });
      // let a = localStorage.getItem('homeProject')
      // localStorage.setItem('homeProject',{...a,projectType:scope.row.projectType})
      // this.$store.dispatch('homeProject',123123)

      //点击接收
      // let signingId;
      // let delEvent = scope => {
      //   let { $index, row } = scope;
      //   this.submitAjax(scope.row.projectType)({
      //     id: row.id
      //   })
      //     .then(res => {
      //       signingId = res.data.data.singingId;
      //       this.$notify({
      //         title: '成功',
      //         message: '接收成功',
      //         type: 'success'
      //       });
      //       this.initWatchRouteChange();
      //       this.makeSureEvent(conTractEvent, scope, '是否签约电子合同');
      //     })
      //     .catch(err => {
      //       console.error(err);
      //     });
      // };
      // let conTractEvent = scope => {
      //   let win = new OpenNewWin();
      //   win.createWin();
      //   let { $index, row } = scope;
      //   if (!ysId.includes(row.projectType)) {
      //     eContract.firstSign({ id: row.id, signingId }).then(res => {
      //       win.setUrl(res.data.data.signUrl);
      //     });
      //   } else {
      //     eContract
      //       .firstYshSign({ id: row.id, signingId: row.signingId })
      //       .then(res => {
      //         win.setUrl(res.data.data.signUrl);
      //       });
      //   }
      // };

      // this.makeSureEvent(delEvent, scope);
    },
    async detail(scope) {
      const {
        row: { signType }
      } = scope;
      let name = scope.row.projectType;
      let projectId = scope.row.projectId;
      let month = scope.row.taskMonth;
      let taskMonth = scope.row.taskMonth;
      let id = scope.row.id;
      let statementId = scope.row.id;
      localStorage.projectType = name;
      let serviceSubitem = '';
      if (scope.row.projectType == 20) {
        const {
          data: { data }
        } = await eContract.queryserviceSubitem({
          projectId,
          type: [8, 7].includes(scope.row.projectType) ? 2 : 1
        });
        serviceSubitem = (data || {}).serviceSubitem;
      }
      this.setHomeQuery({ ...scope.row, serviceSubitem, id: projectId }).then(
        res => {
          const type1 = {
            projectId,
            month,
            id: projectId,
            taskMonth,
            statementId,
            signType
          };
          const type2 = {
            projectId,
            month,
            id: projectId,
            questionnaireAnswerId: id,
            taskMonth,
            statementId,
            signType
          };
          if (name == 5 || name == 7) {
            this.$router.push({
              name: this.projectAllList[name - 1].filePath + 'RecordList',
              query: type2
            });
          } else {
            this.$router.push({
              name: this.projectAllList[name - 1].filePath + 'RecordList',
              query: type1
            });
          }
        }
      );
    },
    saveProId(obj) {
      this.searchQuery.enterpriseId = obj.id;
    }
  },
  filters: {
    transAuditStatus(val) {
      if (val.csoStatus == 0) {
        return '乙方未提交';
      } else {
        if (val.industryConfirm == 0) {
          return '未接收';
        } else {
          return '已接收';
        }
      }
    },
    transContract(row) {
      if (row.status == 0) {
        return '无';
      } else {
        if (row.status == 1) {
          return '待我签';
        } else if (row.status == 2) {
          return '已完成';
        } else if (row.status == 3) {
          return '签约失败';
        } else if (row.status == 4) {
          return '待他签';
        } else if (row.status == 5) {
          return '线下签署';
        } else if (row.status == 6) {
          return '待确认';
        }
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
  padding: 40px 15px;
}
</style>
